import { useEffect, useState } from "react";
import { searchDealerAdminCustomers } from "../../../services/dealerGarage";

const SHOWN = 20;

// "Jane Doe (jane@example.com)" -> ["jane", "doe", "jane@example.com"]
export const searchWords = (text) => String(text || "").toLowerCase().split(/[\s()]+/).filter(Boolean);

// Whether an account matches every word, in any of its name or email.
export const matchesAllWords = (user, words) => {
  const hay = `${user.firstName || ""} ${user.lastName || ""} ${user.email || ""}`.toLowerCase();
  return words.every((word) => hay.includes(word));
};

/**
 * Customer accounts matching what staff typed, searched on the server as they
 * type, so an account made after the page loaded is found too (the pickers
 * used to filter a list fetched with the page). The server matches a single
 * word, so it gets the longest one - usually the most telling, and the email
 * in a picked "Jane Doe (jane@example.com)" label - and the rest are checked
 * here. Searches only while `enabled` (the picker's list is open).
 */
const useCustomerSearch = (text, enabled = true) => {
  const [results, setResults] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const words = searchWords(text);
    const longest = words.reduce((best, word) => (word.length > best.length ? word : best), "");
    // Wait for a pause in typing; open the list straight away.
    const timer = setTimeout(() => {
      // More rows when the other words still have to narrow them down.
      searchDealerAdminCustomers(longest, words.length > 1 ? 100 : SHOWN)
        .then((res) => {
          if (!live) return;
          const rows = Array.isArray(res && res.data) ? res.data : [];
          setResults(rows.filter((user) => matchesAllWords(user, words)).slice(0, SHOWN));
        })
        .catch(() => { if (live) setResults([]); });
    }, words.length ? 250 : 0);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [text, enabled]);
  return results;
};

export default useCustomerSearch;
